import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import McpTyping from '@/components/ani/mcp-loading/typing';
import { SVGPureIcon } from '@/ui';
import CircleLoading from '@/components/ani/circle-loading';
import Loader from '@/common/helper/loader';
import noticeStore from '@/store/notice';

const McpQueueLoading = observer((props) => {
  const {
    chatStore,
    isLastMessage,
    messageItem,
  } = props;

  return (
    chatStore.isAITyping && isLastMessage
    ? (
      chatStore.queueCount > 0
      ? (
        <div className="">
          <div className={`flex mt-12px h-78px w-4/5 rounded-12px flex-col justify-center pl-16px pr-16px bg-white border-1px border-black border-opacity-10`}>
            <div className="flex h-20px items-center">
              <SVGPureIcon name={`mcp_error`} className='size-16px mr-8px text-[#006AFF] flex-shrink-0' />
              <div className="font-bold">服务器资源紧张，任务已加入队列。</div>
            </div>
            
            <div className="mt-6px pl-24px text-black text-opacity-50">
              前边还有 {chatStore.queueCount}个 任务，请耐心等待...
            </div>
          </div>
          {
            true
            ? (
              <div className={`flex w-4/5 mt-12px w-full h-52px rounded-12px items-center border-1px border-black border-opacity-10`}>
                <img src="https://p3.ssl.qhimg.com/t11098f6bcd96f44697a131b945.png" alt="" className="size-20px ml-12px" />
                <div className="text-14px leading-20px text-black ml-10px w-0 flex-grow truncate">
                  任务完成后通知我
                </div>
                {
                  chatStore.hasOrderQueueNotice
                  ? (
                      <div 
                        className="w-74px h-28px rounded-full flex items-center justify-center text-black text-opacity-30 mr-12px text-14px bg-black bg-opacity-6"
                        >
                        已确认
                      </div>
                    )
                  : (
                    <div 
                      className="w-80px h-28px rounded-full flex items-center justify-center text-white mr-12px text-14px bg-black cursor-pointer"
                      onClick={
                        () => {
                          noticeStore.getPermission()
                          .then(() => {
                            chatStore.setHasOrderQueueNotice(true);
                          });
                        }
                      }>
                      启用通知
                    </div>
                  )
                }
              </div>
            )
            : null
          }
          <div className={`flex mt-12px h-32px w-max max-w-full rounded-full items-center pl-10px pr-16px bg-[#006AFF0F]`}>
            <CircleLoading className="!size-16px ml-6px flex-shrink-0" icon={Loader.resources.loading.blue} />
            <div className={`text-14px leading-20px text-black ml-10px font-bold truncate text-[#006AFF]`}>
              关闭对话页，仍将继续排队、执行任务
            </div>
          </div>
        </div>
      )
      : <McpTyping />
    )
    : null
  )
});
export default McpQueueLoading;